export default "__VITE_ASSET__BDIwTBNm__"